import React from "react";
export default function MainProductSection(){

    const mainContainerStyle = {
        width: '100%',
        display: 'flex',
        height: '500px',
    }
    const imageStyle = {
        width: '100%',
        objectFit: 'cover',
        filter: 'grayscale(80%) blur(5px)'
    }
    return(
        <>
            <div style={mainContainerStyle}>
                <img style={imageStyle} src="/resources/welding.jpg"></img>
            </div>
        </>
    )
}